<template>
    <Head :title="t('pages.calendarIntegrationTeamsSuccess.title')" />
    <div class="flex flex-col min-h-screen overflow-y-auto h-screen bg-surface text-ink">
        <div class="fade-in grow justify-center gap-5 md:gap-10 flex flex-col items-center py-4 md:py-10">
            <div class="flex flex-col gap-4 justify-around text-center max-w-sm mx-auto px-4">
                <div class="flex flex-col pb-5 justify-center">
                    <img :src="Logo" :alt="t('common.valenceLogoAlt')" class="mx-auto h-16 w-auto" />
                </div>
            </div>
            <template v-if="error">
                <div class="rounded-lg max-w-md bg-status-error-soft px-6 py-4">
                    <p>{{ error }}</p>
                </div>
            </template>
            <template v-else>
                <LoadingSpinner v-if="loading" class="w-10 h-10" />
                <div v-else class="rounded-lg max-w-md py-4 text-center">
                    <p>{{ t("pages.calendarIntegrationTeamsSuccess.success") }}</p>
                    <p>{{ t("pages.calendarIntegrationTeamsSuccess.closeInstruction") }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import Logo from "~img/color-logo.svg";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { error } = defineProps({
    error: { type: String, default: null },
});

const loading = ref(true);

onMounted(() => {
    logUserInteraction("calendar_integration_teams_success_screen");
});

// Still try to autoclose in case users are on the web version of Teams
setTimeout(() => {
    if (!error) {
        try {
            window.close();
        } catch (closeError) {
            console.warn("Could not auto-close window:", closeError);
        }
        loading.value = false;
    }
}, 1000);
</script>
